<template>
  <page>
    <template slot="header">
      <div class="container-fluid mb-2">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark font-weight-normal">
                {{ $t('Inventário') }}
            </h3>

          </div>
          <div class="col-sm-6">
            <b-breadcrumb class="float-sm-right" :items="breadcrumbItems"></b-breadcrumb>
          </div>
        </div>
      </div>

    </template>
    <template slot='content'>
      <inventario-component></inventario-component>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import InventarioComponent from '../components/Armazem/InventarioComponent.vue'

export default {
  components: {
    Page,
    InventarioComponent
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created() {
    const dsColaborador = this.$store.getters['filial/filial']

  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: this.$t('Inventário de estoque'),
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
  }
}
</script>
